import * as Sentry from '@sentry/nuxt';

Sentry.init({
  disabled: !['production', 'staging'].includes(process.env.NODE_ENV),
  dsn: process.env.SENTRY_CLIENT_URL,
  sourceMapStyle: 'source-map',
  publishRelease: false,
  tracesSampleRate: 0,
  tracing: false,
  telemetry: false,
  sourcemaps: {
    assets: ['./.nuxt/dist/client/**'],
  },
  tracingOptions: {
    hooks: ['activate', 'create', 'mount', 'update'],
    timeout: 2000,
    trackComponents: true,
  },
  clientIntegrations: {
    Dedupe: {},
    ExtraErrorData: {},
    ReportingObserver: false,
    RewriteFrames: {},
  },
});
